
var affixElements = document.querySelectorAll('[data-affix]');
document.addEventListener('scroll', function() {
    for (let i = 0; i < affixElements.length; i++) {
        scroll(affixElements[i])
    }
})
for (let i = 0; i < affixElements.length; i++) {
    scroll(affixElements[i])
}

function scroll (e) {
    var target = e;
    var scrollTop = window.pageYOffset;
    if( scrollTop > target.getAttribute('data-offset-top') ){
        target.classList.add("affix");
    }
    else
    {			
        target.classList.remove("affix");
    }
}